import { z } from 'zod'

import { metroAreaSchema } from '../branches/api'

// Role type definition
export const UserRoleSchema = z.enum(['SUPERADMIN', 'ADMIN', 'MANAGER'])
export type UserRole = z.infer<typeof UserRoleSchema>

export const BranchInfoSchema = z.object({
  provider_branch_id: z.string(),
  metro_area: metroAreaSchema.nullable(),
  labor_rate: z.number().nullable(),
  stripe_account_id: z.string().nullable(),
})
export type BranchInfo = z.infer<typeof BranchInfoSchema>
// Schema definitions
export const UserSchema = z.object({
  id: z.string(),
  provider_id: z.string(),
  email: z.string().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  is_active: z.boolean(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date().nullable(),
  email_notification: z.boolean(),
  mobile_phone_number: z.string().nullable(),
  role: UserRoleSchema,
  text_notifications_enabled: z.boolean(),
})

export const UserWithBranchesSchema = UserSchema.extend({
  branchInfo: z.array(BranchInfoSchema).nullable(),
})

export type User = z.infer<typeof UserSchema>
export type UserWithBranches = z.infer<typeof UserWithBranchesSchema>
